import React, { useEffect } from "react";
import Primarycarecon from "./Primarycarecon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function Primarycare() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Primarycarecon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Primary Care Services in Whitefield</title>
        <meta
          name="description"
          content="Are you looking for the best primary care services in Whitefield? Then you are in the right place. Contact us today."
        />
        <meta
          name="keywords"
          content="Best Primary care services in Whitefield, Best Primary care services in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestprimarycareservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestprimarycareservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics provides comprehensive primary care services in Whitefield, Bangalore including preventive checkups, chronic disease management, routine health screenings, general consultations, and patient-centred medical guidance.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Routine medical consultations",
              "Preventive health checkups",
              "Chronic disease screening & management",
              "Immunizations & vaccinations",
              "Health education & lifestyle counselling",
              "General wellness advice",
              "Referrals to specialists",
            ],
            keywords: [
              "Best Primarycare Services in Immadihalli",
              "Best Primarycare Services in Whitefield",
              "Best Primarycare Services in Bangalore",
              "Best Primarycare Services in Kundalahalli",
              "Best Primarycare Services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Primary care services in Whitefield guiding you on your journey to a
        healthier and happier life. Contact us today for the best primary care
        services in Whitefield.
      </h2>

      <Servicebanner name="Primary care" banner={"../photo/dd21.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
                <Divider />
              </div>
              <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Primarycare;
